import { trim } from 'lodash'
import { wrapObjectFunctions } from './wrapObjectFunctions'
import { createError } from '../errors'

const requestBreadcrumb = (fnName, args) => ({
  category: 'editorSDK Request',
  message: `${fnName}(${trim(JSON.stringify(args), '[]')})`,
})

const responseBreadcrumb = (fnName, value) => ({
  category: 'editorSDK Response',
  message: `${fnName} -> ${JSON.stringify(value)}`,
})

const errorBreadcrumb = (fnName, error) => ({
  category: 'editorSDK Error',
  message: `${fnName} -> ${error?.stack || JSON.stringify(error)}`,
})

const eventBreadcrumb = (eventType, eventPayload) => ({
  category: 'editorSDK Event',
  message: `Type: ${eventType}. Payload: ${JSON.stringify(eventPayload)}`,
})

export const wrapWithBreadcrumbs = ({ editorSDK, onBreadcrumb }) => {
  const beforeApiCall = (fnName, args) =>
    onBreadcrumb(requestBreadcrumb(fnName, args))

  const afterApiCall = (fnName, promiseOrValue) => {
    if (!(promiseOrValue instanceof Promise)) {
      onBreadcrumb(responseBreadcrumb(fnName, promiseOrValue))
      return promiseOrValue
    }

    const invoke = async () => {
      try {
        const value = await promiseOrValue
        onBreadcrumb(responseBreadcrumb(fnName, value))
        return value
      } catch (error) {
        onBreadcrumb(errorBreadcrumb(fnName, error))
        throw createError('EditorSDK error', {
          cause: error,
          method: fnName,
        })
      }
    }

    return invoke()
  }

  const wrappedApi = wrapObjectFunctions(editorSDK, beforeApiCall, afterApiCall)

  const wrappedOnEvent = {
    onEvent: cb =>
      editorSDK.panel.onEvent(({ eventType, eventPayload }) => {
        onBreadcrumb(eventBreadcrumb(eventType, eventPayload))
        // eslint-disable-next-line
        cb({ eventType, eventPayload })
      }),
  }

  wrappedApi.panel = Object.assign({}, wrappedApi.panel, wrappedOnEvent)

  return wrappedApi
}
